import type { ReactNode } from 'react';

export function SectionHeader({
  title,
  action,
  className = '',
}: {
  title: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`mb-3 flex items-center justify-between gap-3 ${className}`}>
      <h2 className="font-display text-lg font-bold tracking-tight text-[var(--text-primary)]">{title}</h2>
      {action}
    </div>
  );
}
